/**
 * Filters the passed (async) iterable by using the filter function
 */
export default async function* filter(source, fn) {
    for await (const entry of source) {
        if (await fn(entry)) {
            yield entry;
        }
    }
}
